import Admin from "../views/Admin";

import KartaKlienti from "../containers/broker/KartaKlienti/KartaKlienti";
import KartaHypoteky from "../containers/broker/KartaHypoteky/KartaHypoteky";
import KartaHypotekyDetail from "../containers/broker/KartaHypoteky/KartaHypotekyDetail";
import KartaZiadosti from "../containers/broker/KartaZiadosti/KartaZiadosti";
import KartaPosudky from "../containers/expert/KartaPosudky/KartaPosudky";
import KartaNastavenia from "../containers/broker/KartaNastavenia/KartaNastavenia.vue";
import { legacyMarketingLocation } from "@/utils/marketingNavigation";
import KartaServis from "@/containers/broker/KartaServis/KartaServis.vue";

const adminRoutes = {
  name: "RoleRoutes",
  component: Admin,
  path: "",
  redirect: KartaKlienti,
  children: [
    {name: "MarketingStudio", path: "/marketing-studio/", redirect: to => ({name: "KartaMarketing", query: {...to.query, section: "social"}}), meta: {requiredRole: "alex_admin"}},
    {name: "MarketingOverview", path: "/marketing/", redirect: to => ({name: "KartaMarketing", query: {...to.query, section: "google-ads"}}), meta: {requiredRole: "alex_admin"}},
    {name: "KartaMarketing", path: "/karta-marketing/", component: () => import("../containers/broker/Marketing/KartaMarketing.vue"), meta: {requiredRole: "alex_admin"}},
    {
      name: "KartaHypoteky",
      component: KartaHypoteky,
      path: "/karta-hypoteky/",
    },
    {
      name: "KartaHypotekyDetail",
      component: KartaHypotekyDetail,
      path: "/karta-hypoteky/:hypoteka/detail",
    },
    {
      name: "KartaKlienti",
      component: KartaKlienti,
      path: "/karta-klienti/",
    },
    {
      name: "KartaZiadosti",
      component: KartaZiadosti,
      path: "/karta-ziadosti/",
    },
    {
      name: "KartaServis",
      component: KartaServis,
      path: "/karta-servis/",
    },
    {
      name: "KartaPosudky",
      component: KartaPosudky,
      path: "/karta-posudky/",
    },
    {
      name: "KartaNastavenia",
      component: KartaNastavenia,
      beforeEnter(to, from, next) { const target = legacyMarketingLocation(to.query); next(target || undefined); },
      path: "/karta-nastavenia/",
      meta: {
        requiredRole: "alex_admin",
      },
    },
  ],
}

export default adminRoutes;
